import React from 'react'
import { useFormContext } from 'react-hook-form'
import { IconButton, InputAdornment } from '@material-ui/core'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import { components } from 'cng-web-lib'

const { form: { field: { CngSelectField } } } = components

function ClearableCngSelectField({ name, value: valueProp, onChange, disabled, ...props }) {
  const { watch, setValue } = useFormContext()
  const isControlled = valueProp !== undefined
  const currentValue = isControlled ? valueProp : (name ? watch(name) : '')

  function handleClear() {
    if (isControlled) {
      onChange && onChange({ target: { value: '' } })
    } else if (name) {
      setValue(name, '', { shouldValidate: true })
    }
  }

  const controlledProps = isControlled ? { value: valueProp, onChange } : {}

  return (
    <CngSelectField
      name={name}
      disabled={disabled}
      InputProps={
        currentValue && !disabled
          ? {
              endAdornment: (
                <InputAdornment position='end' style={{ marginRight: 24 }}>
                  <IconButton
                    size='small'
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => { e.stopPropagation(); handleClear() }}
                  >
                    <HighlightOffIcon style={{ fontSize: 18 }} />
                  </IconButton>
                </InputAdornment>
              )
            }
          : undefined
      }
      {...controlledProps}
      {...props}
    />
  )
}

export default ClearableCngSelectField
